import { render, staticRenderFns } from "./ReportIndicatorLightMini.vue?vue&type=template&id=2fd825b0"
import script from "./ReportIndicatorLightMini.vue?vue&type=script&lang=js"
export * from "./ReportIndicatorLightMini.vue?vue&type=script&lang=js"
import style0 from "./ReportIndicatorLightMini.vue?vue&type=style&index=0&id=2fd825b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports